import {TRANSLATED_LANGUAGES} from './Language';

export const DIGITAL_CERTIFICATE_TRANSLATE_KEYS_MAP: Record<TRANSLATED_LANGUAGES, string> = {
  [TRANSLATED_LANGUAGES.czech]: 'cs',
  [TRANSLATED_LANGUAGES.english]: 'en',
  [TRANSLATED_LANGUAGES.germany]: 'de',
  [TRANSLATED_LANGUAGES.poland]: 'pl',
  [TRANSLATED_LANGUAGES.slovak]: 'sk',
  [TRANSLATED_LANGUAGES.spain]: 'es',
  [TRANSLATED_LANGUAGES.italy]: 'it',
  [TRANSLATED_LANGUAGES.france]: 'fr',
};
